export enum Components {
  LANDING_PAGE = 'LandingPage',
  DEBT_OVERVIEW_PAGE_DATA = 'DebtOverviewPageData',
  UPDATE_PAYMENT_PLAN_START_PAGE_DATA = 'UpdatePaymentPlanStartPageData',
  CUSTOMER_PROFILE_PAGE_DATA = 'CustomerProfilePageData',
  DIRECT_PAYMENT_FRANCE_PAGE_DATA = 'DirectPaymentFrancePageData',
  DIRECT_PAYMENT_GERMANY_PAGE_DATA = 'DirectPaymentGermanyPageData',
  DIRECT_PAYMENT_ITALY_PAGE_DATA = 'DirectPaymentItalyPageData',
  DIRECT_PAYMENT_BELGIUM_PAGE_DATA = 'DirectPaymentBelgiumPageData',
  DIRECT_PAYMENT_POLAND_PAGE_DATA = 'DirectPaymentPolandPageData',
  DIRECT_PAYMENT_NETHERLANDS_PAGE_DATA = 'DirectPaymentNetherlandsPageData',
  DIRECT_PAYMENT_SPAIN_PAGE_DATA = 'DirectPaymentSpainPageData',
  UPDATE_PAYMENT_PLAN_CHANGE_AMOUNT_PAGE_DATA = 'UpdatePaymentPlanChangeAmountPageData',
  CHOOSE_YOUR_PLAN_PAGE_DATA = 'ChooseYourPlanPageData',
  PAYMENT_PLAN_CHOOSE_PAYMENT_METHOD_PAGE_DATA = 'PaymentPlanChoosePaymentMethodPageData',
  PAYMENT_PLAN_CONFIRM_MANUAL_PAGE_DATA = 'PaymentPlanConfirmManualPageData',
  UPDATE_PAYMENT_PLAN_CHANGE_DATE_PAGE_DATA = 'UpdatePaymentPlanChangeDatePageData',
  ENTER_DISPOSABLE_INCOME_PAGE_DATA = 'EnterDisposableIncomePageData',
  DISPOSABLE_INCOME_TOO_LOW_PAGE_DATA='DisposableIncomeTooLowPageData',
  UPDATE_PAYMENT_PLAN_CONFIRM_PAGE_DATA = 'UpdatePaymentPlanConfirmPageData',
  UPDATE_PAYMENT_PLAN_SUMMARY_PAGE_DATA = 'UpdatePaymentPlanSummaryPageData',
  PAYMENT_PLAN_CONFIRM_PAGE_DATA = 'PaymentPlanConfirmPageData',
  PAYMENT_PLAN_SUMMARY_PAGE_DATA = 'PaymentPlanSummaryPageData',
  DIRECT_PAYMENT_SUMMARY_PAGE_DATA = 'DirectPaymentSummaryPageData',
  UPDATE_PAYMENT_PLAN_CHANGE_PAYMENT_TYPE_PAGE_DATA = 'UpdatePaymentPlanChangePaymentTypePageData',
  UPDATE_PAYMENT_PLAN_CHANGE_PAYMENT_TYPE_CONFIRM_PAGE_DATA = 'UpdatePaymentPlanChangePaymentTypeConfirmPageData',
  PAYMENT_PLAN_CONFIRM_SCHEDULE_PAGE_DATA = 'PaymentPlanConfirmSchedulePageData',
  EDIT_EMAIL_PAGE_DATA='EditEmailPageData',
  EDIT_ADDRESS_PAGE_DATA='EditAddressPageData',
  EDIT_PHONE_PAGE_DATA='EditPhonePageData',
  OFFERR_DIRECT_PAYMENT_PAGE_DATA = 'OfferDirectPaymentPageData',
  LOGIN_PAGE_DATA = 'LoginPageData',
  REGISTRATION_VERIFY_EMAIL_SMS_PAGE_DATA = 'RegistrationVerifyEmailSmsPageData',
  INCOME_AND_EXPENDITURES_PAGE_DATA = 'IncomeAndExpendituresPageData',
  VERIFY_IDENTITY_FRANCE_PAGE_DATA = 'VerifyIdentityFrancePageData',
  VERIFY_IDENTITY_GERMANY_PAGE_DATA = 'VerifyIdentityGermanyPageData',
  VERIFY_IDENTITY_ITALY_PAGE_DATA = 'VerifyIdentityItalyPageData',
  VERIFY_IDENTITY_BELGIUM_PAGE_DATA = 'VerifyIdentityBelgiumPageData',
  VERIFY_IDENTITY_POLAND_PAGE_DATA = 'VerifyIdentityPolandPageData',
  VERIFY_IDENTITY_NETHERLANDS_PAGE_DATA = 'VerifyIdentityNetherlandsPageData',
  VERIFY_IDENTITY_SPAIN_PAGE_DATA = 'VerifyIdentitySpainPageData',
  RESET_PASSWORD_PAGE_DATA = 'ResetPasswordPageData',
  REGISTRATION_VERIFY_OTP_PAGE_DATA = 'RegistrationVerifyOtpPageData',
  REQUEST_CALLBACK_PAGE_DATA = 'RequestCallBackPageData',
  VERIFY_IDENTITY_WITHOUT_DEBTREFERENECE_PAGE_DATA = 'VerifyIdentityWithoutDebtReferencePageData',
  CONTACT_DETAILS_UPDATE_CONFIRMATION_PAGE_DATA = 'ContactDetailsUpdateConfirmationPageData',
  EMAIL_VERIFICATION_PAGE_DATA='EmailVerificationPageData',
  MOBILE_VERIFICATION_PAGE_DATA='MobileVerificationPageData',
  GENERIC_ERROR_PAGE = 'GenericErrorPageData',
  PAYMENT_PLAN_CONFIRM_POLAND_PAGE_DATE='PaymentPlanConfirmPolandPageData',
  UPADTE_PAYMENT_PLAN_CONFIRM_TABLE_PAGE_DATA='UpdatePaymentPlanConfirmTablePageData',
  TRANSACTION_HISTORY_PAGE_DATA='TransactionHistoryPageData',
  DOCUMENTS_PAGE_DATA = 'DocumentsPageData' 
}
